import { memo } from 'react';
import { useLoadDevbar, useDevbarInteraction } from '@dbh/development-redux';
import TappableSecretZone from '@dbh/tappable-secret-zone';
import { jsx } from 'react/jsx-runtime';

const TappableSecretDevbarZone=/*#__PURE__*/memo(a=>{const b=useLoadDevbar(),[c]=useDevbarInteraction(b);return/*#__PURE__*/jsx(TappableSecretZone,{onClick:c,onDoubleClick:c,...a})});TappableSecretDevbarZone.displayName="TappableSecretDevbarZone";

export { TappableSecretDevbarZone as default };
